import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "detail app-width cf pdg",
  "data-pdgb": "80",
  "data-offer": "true"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  class: "account mrg",
  "data-mrgt": "20"
}
const _hoisted_4 = { class: "login" }
const _hoisted_5 = {
  key: 0,
  class: "form"
}
const _hoisted_6 = { class: "item" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "form-items cf" }
const _hoisted_9 = {
  key: 0,
  class: "item"
}
const _hoisted_10 = { class: "control" }
const _hoisted_11 = {
  class: "label",
  for: "UserName"
}
const _hoisted_12 = { class: "item" }
const _hoisted_13 = { class: "control" }
const _hoisted_14 = {
  class: "label",
  for: "Email"
}
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { class: "control" }
const _hoisted_17 = {
  class: "label",
  for: "Password"
}
const _hoisted_18 = { class: "fieldset" }
const _hoisted_19 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_20 = {
  class: "form-items",
  "data-type": "buttons"
}
const _hoisted_21 = { class: "item calltoaction" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "lable" }
const _hoisted_24 = {
  key: 1,
  "data-pdgb": "80",
  "data-offer": "true",
  class: "detail app-width cf pdg"
}
const _hoisted_25 = { class: "title" }
const _hoisted_26 = {
  "data-mrgt": "20",
  "data-line": "false",
  class: "subtitle mrg"
}
const _hoisted_27 = { class: "txt" }
const _hoisted_28 = {
  "data-mrgt": "40",
  class: "calltoaction mrg"
}
const _hoisted_29 = {
  href: "/",
  class: "button"
}

import { onBeforeMount, ref } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountEdit',
  props: {
    returnUrl: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(true);
const isSuccess = ref(false);
const options = ref<any>(null);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);

async function getData() {
    const response = (await Axios.post(routes.Account_Edit_GetData)).data;
    formData.value = response;
    isLoading.value = false;
}

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    await getData();
});

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];
    isLoading.value = true;

    formData.value.returnUrl = props.returnUrl;

    try {
        await Axios.post(routes.Account_Edit, formData.value);

        isSuccess.value = true;

        GTagHelper.sendEvent("form_submit", "account_login");
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoading.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (!isSuccess.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(localizer).get("Account.Common.Edit_Title")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (options.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("fieldset", {
                      class: "fieldset mrg",
                      "data-mrgt": "20",
                      disabled: isLoading.value
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        (options.value.isUserName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(localizer).get("Account.Common.UserName")), 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  id: "UserName",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.userName) = $event)),
                                  autocomplete: "email",
                                  class: _normalizeClass([{ 'input-validation-error': isValidationError('UserName') }, 'textbox short'])
                                }, null, 2), [
                                  [
                                    _vModelText,
                                    formData.value.userName,
                                    void 0,
                                    { lazy: true }
                                  ]
                                ]),
                                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(localizer).get("Account.Common.Email")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "email",
                              id: "Email",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                              autocomplete: "email",
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'textbox short'])
                            }, null, 2), [
                              [
                                _vModelText,
                                formData.value.email,
                                void 0,
                                { lazy: true }
                              ]
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(localizer).get("Account.Common.Password")), 1),
                            _createElementVNode("input", {
                              type: "password",
                              id: "Password",
                              value: "*********",
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Password') }, 'textbox short']),
                              disabled: ""
                            }, null, 2)
                          ])
                        ])
                      ])
                    ], 8, _hoisted_7),
                    _createElementVNode("fieldset", _hoisted_18, [
                      (validationErrors.value.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("button", {
                            id: "ButtonSubmit",
                            class: "button",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm())),
                            disabled: isLoading.value
                          }, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
                          ], 8, _hoisted_22)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_24, [
        _createElementVNode("h1", _hoisted_25, _toDisplayString(_unref(localizer).get("Account.Common.StatusMessage_Edit_Title")), 1),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("h2", _hoisted_27, _toDisplayString(_unref(localizer).get("Account.Common.ProfileUpdateSuccess")), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("a", _hoisted_29, _toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
        ])
      ]))
}
}

})